import { render, staticRenderFns } from "./DetailsModal.vue?vue&type=template&id=9296eafc&scoped=true&lang=pug"
import script from "./DetailsModal.vue?vue&type=script&lang=js"
export * from "./DetailsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9296eafc",
  null
  
)

export default component.exports